module.exports = __webpack_public_path__ + "static/media/team_bond_mobile.98b215e0.png";